import { render, staticRenderFns } from "./DeliveryConnectionNotice.vue?vue&type=template&id=073cf5fe"
import script from "./DeliveryConnectionNotice.vue?vue&type=script&lang=js"
export * from "./DeliveryConnectionNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports